<template>
  <LexonTooltipComponent :message="props.title" position="top" isWidthAuto>
    <div slot="activator-element">
      <span class="lf-header-title" ref="textElement">{{ props.title }}</span>
    </div>
  </LexonTooltipComponent>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'
import LexonTooltipComponent from '@/components/forms/fields/LexonTooltip/LexonTooltipComponent.vue'

// PROPS
const props = defineProps({
  title: {
    type: String as PropType<string>,
    required: true
  }
})
</script>

<style lang="scss" scoped>
.lf-header-title {
  @include ellipsis;
  display: block;
}
</style>
